/** @format */

import axios from 'axios';

import { notification } from 'antd';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';

import { Loading } from '../../../components/Loading';
import { Response } from '../../../components/Response';

import { ENV_COUNTRY, ENV_FUNCTION_QUOTATION } from '../../../hooks/enviroment';

const dataUser = GetLocalStorageValue(LOCAL_STORAGE.USER);

export async function serviceGetQuotation(item) {
	let urlRequest = '';
	if (!!item.pharmacy) {
		urlRequest = `${ENV_FUNCTION_QUOTATION}/tracking/${ENV_COUNTRY}/${item._id}`;
	} else {
		urlRequest = `${ENV_FUNCTION_QUOTATION}/find/${item.rut}/${item.short_code}`;
	}
	return await axios({
		method: 'GET',
		url: urlRequest,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				return response.data.data;
			} else {
				notification.error({
					message: response.data.error,
					description: response.data.message,
				});
				return {};
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_QUOTATION}/tracking/${ENV_COUNTRY}/${item._id}`,
			});
		});
}

export async function serviceProcessNewStatus(item) {
	Loading.open();
	let itemSend = {};
	if (item.status === 200 || item.status === 500) {
		itemSend = {
			tracking_id: item._id,
			status_target: item.status,
			reason: item.reason,
			qf_email: dataUser.email,
		};
	} else {
		itemSend = {
			tracking_id: item._id,
			status_target: item.status,
			qf_email: dataUser.email,
			reason: item.quotationType === 'magistral' && item.observation?.length > 0 ? item.observation : '',
			data_approve: {
				estimated_date: item.scheduleSelected,
				price: item.price,
				quantity: item.quotationType === 'magistral' ? 1 : item.quantity,
			},
		};
	}
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_QUOTATION}/tracking/${ENV_COUNTRY}/process`,
		data: itemSend,
	})
		.then((response) => {
			Loading.close();
			Response.open(response.data, 'quiotation-tracking');
			if (response.data.statusCode === 200) {
				return true;
			} else {
				return false;
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_QUOTATION}/tracking/${ENV_COUNTRY}/process`,
			});
		});
}

export async function serviceQuotationDigitalUpdateStatus(item) {
	Loading.open();
	let dataSend = {
		code: item.short_code,
		rut: item.rut,
	};
	let urlRequest = ``;
	if (item.newStatus === 'completed') {
		urlRequest = `${ENV_FUNCTION_QUOTATION}/${ENV_COUNTRY}`;
		dataSend = {
			...dataSend,
			item_products: item.item_products,
		};
	} else {
		urlRequest = `${ENV_FUNCTION_QUOTATION}/${ENV_COUNTRY}/cancelation`;
		dataSend = {
			...dataSend,
			reason: item.reason,
		};
	}
	return await axios({
		method: item.newStatus === 'completed' ? 'PUT' : 'POST',
		url: urlRequest,
		data: dataSend,
	})
		.then((response) => {
			Loading.close();
			Response.open(response.data, 'quotation-digital');
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_QUOTATION}/${ENV_COUNTRY}`,
			});
		});
}
